import request from "../../../request";

export default {
  actions: {
    getDefinitions(_, payload) {
      return request.get('definitions', {
        params: payload,
      })
    },

    createDefinition(_, data) {
      return request.post('definitions', data);
    },

    updateDefinition(_, payload) {
      return request.put('definitions/' + payload.id, payload);
    },

    deleteDefinition(_, id) {
      return request.delete('definitions/' + id);
    },
  }
}
